/**
 * Healthcare Model Configuration
 * COMPLETE extraction from /server/healthcare/healthcare-api.js
 */

import type { ModelConfig } from '@/types/models';
import { standardResultTabs } from '@/config/resultTabs';

export const healthcareConfig: ModelConfig = {
  modelType: 'healthcare',
  apiEndpoint: '/api/healthcare',
  displayName: 'Healthcare',
  resultTabs: standardResultTabs,
  description: 'Medical practice model with patient visits, insurance reimbursement, and clinical operations.',
  icon: '🏥',
  color: '#ef4444',

  assumptionGroups: [
    {
      id: 'user-details',
      title: '👤 Your Details',
      fields: [
        { id: 'userEmail', label: 'Your Email', type: 'email', placeholder: 'name@company.com' },
      ],
    },
    {
      id: 'core-revenue',
      title: '💰 Core Revenue Drivers',
      fields: [
        { id: 'monthlyPatientVisits', label: 'Monthly Patient Visits', type: 'number', defaultValue: 500 },
        { id: 'revenuePerVisit', label: 'Revenue per Visit ($)', type: 'number', defaultValue: 150 },
        { id: 'insuranceReimbursementRate', label: 'Insurance Reimbursement (%)', type: 'number', defaultValue: 85 },
        { id: 'recurringPatientRate', label: 'Recurring Patient Rate (%)', type: 'number', defaultValue: 40 },
      ],
    },
    {
      id: 'growth',
      title: '📈 Growth',
      fields: [
      ],
    },
    {
      id: 'cost-structure',
      title: '💵 Cost Structure',
      fields: [
        { id: 'staffCostPerVisit', label: 'Staff Cost per Visit ($)', type: 'number', defaultValue: 60 },
        { id: 'supplyCostPerVisit', label: 'Supply Cost per Visit ($)', type: 'number', defaultValue: 15 },
      ],
    },
    {
      id: 'fixed-costs',
      title: '🏢 Fixed Costs',
      fields: [
        { id: 'malpracticeInsuranceMonthly', label: 'Monthly Malpractice Insurance ($)', type: 'number', defaultValue: 2000 },
        { id: 'monthlyRent', label: 'Monthly Rent ($)', type: 'number', defaultValue: 8000 },
      ],
    },
    {
      id: 'financing',
      title: '🏦 Financing',
      fields: [
        { id: 'initialCapitalRaise', label: 'Initial Capital ($)', type: 'number', defaultValue: 300000 },
        { id: 'initialDebtAmount', label: 'Initial Debt ($)', type: 'number', defaultValue: 150000 },
        { id: 'annualInterestRate', label: 'Interest Rate (%)', type: 'number', defaultValue: 6.5 },
        { id: 'automaticCapitalRaise', label: 'Automatic Capital Raise', type: 'checkbox', defaultValue: true, helpText: 'Automatically raise capital when cash goes negative' },
      ],
    },
    {
      id: 'financial-tax',
      title: '🏛️ Financial & Tax',
      fields: [
        { id: 'corporateTaxRate', label: 'Corporate Tax Rate (%)', type: 'number', defaultValue: 25 },
      ],
    },
  ],

};

export const healthcareDefaultAssumptions = {
  monthlyPatientVisits: 500,
  revenuePerVisit: 150,
  insuranceReimbursementRate: 85,
  recurringPatientRate: 40,
  staffCostPerVisit: 60,
  supplyCostPerVisit: 15,
  malpracticeInsuranceMonthly: 2000,
  monthlyRent: 8000,
  initialCapitalRaise: 300000,
  initialDebtAmount: 150000,
  annualInterestRate: 6.5,
  corporateTaxRate: 25,
  automaticCapitalRaise: true,
};
